import SeoHead from "@/Component/Seo/SeoHead";
import Coupons from "@/Component/Module/Coupons";
import {
  serverFetchCouponCategoryList,
  serverFetchCouponHomePageHeading,
  serverFetchCouponList,
  serverFetchCouponModuleList,
} from "@/services/server";
import { getCountryFromContext } from "@/utils/getCountryFromRequest";
import { normalizeHomePageHeading } from "@/utils/homePageHelpers";
import { fetchPageSeo } from "@/utils/pageSeo";

export default function CouponsPage({
  seo,
  seoCountry,
  initialCouponList,
  initialCategories,
  initialModules,
  initialHomePageHeading,
}) {
  return (
    <>
      <SeoHead seo={seo} country={seoCountry} fallbackTitle="Coupons | Next Holidays" />
      <Coupons
        initialCouponList={initialCouponList}
        initialCategories={initialCategories}
        initialModules={initialModules}
        initialHomePageHeading={initialHomePageHeading}
      />
    </>
  );
}

export async function getServerSideProps(context) {
  const country = getCountryFromContext(context);
  const seoResult = await fetchPageSeo(context);
  if (seoResult.redirect) return seoResult;

  try {
    const [couponResponse, categoryResponse, moduleResponse, homePageHeading] =
      await Promise.all([
        serverFetchCouponList(country),
        serverFetchCouponCategoryList(country),
        serverFetchCouponModuleList(country),
        serverFetchCouponHomePageHeading(country),
      ]);

    return {
      props: {
        seo: seoResult.seo,
        seoCountry: seoResult.seoCountry,
        initialCouponList: couponResponse?.data || null,
        initialCategories: Array.isArray(categoryResponse?.data)
          ? categoryResponse.data
          : [],
        initialModules: Array.isArray(moduleResponse?.data)
          ? moduleResponse.data
          : [],
        initialHomePageHeading: normalizeHomePageHeading(homePageHeading),
      },
    };
  } catch (error) {
    console.error("Coupons page SSR error:", error);
    return {
      props: {
        seo: seoResult.seo,
        seoCountry: seoResult.seoCountry,
        initialCouponList: null,
        initialCategories: [],
        initialModules: [],
        initialHomePageHeading: null,
      },
    };
  }
}
